export enum RedirectSearchParam {
    EntryUrl = 'pvEntryUrl',
    Origin = 'origin',
    SearchBoxOpen = 'pvSearchBoxOpen',
    SearchChanged = 'searchChanged',
    ServiceCode = 'pvSrvCd',
    Step = 'pvStep',
}
